<template>
    <kt-panel>
        <div class="create-services">
            <router-link to="/items" class="mr-2">
                <button class="btn btn-success">بازگشت</button>
            </router-link>
        </div>
        <form @submit.prevent="submitRequest($event, query)"
              id="single-request-form"
              class="kt-form p-3 my-4"
        >
            <div class="container p-3 pt-5 my-4 border in-border-header" style="padding-top: 1.5rem !important;">
                <kt-form-section is_first>
                    <div class="section-header online-factor-dark-legend">
                        {{ $t('online-factor.label_create_item') }}
                    </div>
                    <kt-row class="p-2">
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="title">
                                    {{ $t('online-factor.title_item') }}
                                    <span class="text-danger h5 pb-3">*</span>
                                </kt-form-label>
                                <kt-form-control id="title" name="title" v-model="query.title">
                                </kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="item_code">
                                    {{ $t('online-factor.item_code') }}
                                </kt-form-label>
                                <kt-form-control id="item_code" name="item_code" v-model="query.item_code">
                                </kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="description">
                                    {{ $t('online-factor.description') }}
                                </kt-form-label>
                                <kt-form-control id="description" name="description" v-model="query.description">
                                </kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="amount">
                                    {{ $t('online-factor.amount') }}
                                    <span class="text-danger h5 pb-3">*</span>
                                </kt-form-label>
                                <kt-form-control id="amount" name="amount" v-model="query.amount">
                                </kt-form-control>
                                <span style="font-size:1rem;color:#00bea5" v-if="query.amount">
                                       {{ currencyFormat(query.amount) + ' ' + $t('currency.toman') }}
                                 </span>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="quantity">
                                    {{ $t('online-factor.quantity') }}
                                    <span class="text-danger h5 pb-3">*</span>
                                </kt-form-label>
                                <kt-form-control id="quantity" name="quantity" v-model="query.quantity"
                                :disabled="query.is_unlimited">
                                </kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="file">
                                    <kt-icon type="fa" name="paperclip"></kt-icon>
                                    {{ $t('online-factor.image') }}
                                </kt-form-label>
                                <kt-form-control
                                    @change="processFile"
                                    type="file"
                                    class="custom-file-upload"
                                    name="file"
                                    id="file"
                                    accept="image/png,.jpg,.jpeg"
                                />
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group class="my-2">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox"
                                           class="custom-control-input"
                                           id="is_unlimited"
                                           name="is_unlimited"
                                           v-model="query.is_unlimited"
                                    >
                                    <label class="custom-control-label" for="is_unlimited">
                                        {{ $t('online-factor.is_unlimited') }}
                                    </label>
                                </div>
                            </kt-form-group>
                            <kt-form-group class="my-2">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox"
                                           class="custom-control-input"
                                           id="has_tax"
                                           name="has_tax"
                                           v-model="query.has_tax"
                                    >
                                    <label class="custom-control-label" for="has_tax">
                                        {{ $t('online-factor.has_tax') }}
                                    </label>
                                </div>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12" class="d-flex justify-content-end" v-if="query.file">
                            <img :src="picPreview" class="w-25" />
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12" class="d-flex justify-content-end" v-else>
                            <img id="none"  class="w-25" src="@/assets/media/item.png">
                        </kt-col>
                        <kt-col lg="12" md="12" xs="12">
                            <kt-button
                                id="form-btn"
                                class="btn btn-success btn-wide text-center py-2"
                                type="submit"
                                variant="success"
                            >
                                {{ $t('online-factor.label_create_item') }}
                            </kt-button>
                        </kt-col>
                        <kt-col lg="12" md="12" xs="12">

                        </kt-col>
                    </kt-row>
                </kt-form-section>
            </div>
        </form>
    </kt-panel>
</template>

<script>

import $ from "jquery";
import toastr from "toastr";
import { KTApp } from '@/plugins/core/app'
import {onlineFactorService} from "@/common/shop.service";


export default {
    props: {
        submitSingleRequest: {
            default: function($event, query) {},
            type: Function
        },
    },
    data() {
        return {
            query: {
                is_unlimited: false,
                file : false
            },
            picPreview: "",
            backToFactor: false
        }
    },
    computed : {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: true,
                rtl: false
            }

            return toastr
        }
    },
    methods: {
        currencyFormat(price) {
            price = Math.floor(price / 10);
            const pieces = parseFloat(price).toFixed(0).split('');
            let ii = pieces.length;

            while ((ii -= 3) > 0) {
                pieces.splice(ii, 0, ',');
            }

            return pieces.join('');
        },
        processFile(e) {
            this.query.file = e.target.files[0]
            this.picPreview =  URL.createObjectURL(e.target.files[0]);
        },
        submitRequest(e, query) {
            let form = $('#single-request-form')
            let btn = $('#form-btn')

            form.validate( {
                rules: {
                    title: {
                        required: true
                    },
                    amount: {
                        required: true,
                    },
                    item_code: {
                        required: query.item_code ? true : false,
                    },
                    description: {
                        maxlength: 200,
                    },
                    quantity: {
                        required: true,
                    },
                    image: {
                        required: false
                    }
                }
            })

            if (!form.valid()) {
                return;
            }

            let data = {
                title: query.title,
                item_code: query.item_code ? query.item_code : "",
                amount: query.amount,
                description: query.description ? query.description : "",
                is_unlimited: query.is_unlimited,
                quantity: query.quantity,
                has_tax: query.has_tax,
                image: query.file ? query.file : ""
            }

            KTApp.progress(btn)

            onlineFactorService.createItem(data)
                .then(response => {
                    this.toastr.success(response.data.message)
                    if(this.backToFactor){
                        this.$router.push('/online-factor-factor-create')
                    }else{
                        this.$router.push('/items')
                    }
                })
                .catch(({response}) => {
                    this.toastr.error(response.data.message)
                    for(let err in response.data.data){
                        this.toastr.error(response.data.data[err][0])
                    }
                }).finally(response => {
                KTApp.unprogress(btn)
            })
        },
    },
    watch: {
        'query.is_unlimited'(value) {
            if (value) {
                this.query.quantity = "";
            }
        }
    },
    mounted(){
        if(this.$route.params.create){
            this.backToFactor = true
        }
    }
}
</script>
<style scoped>

.preview_img {
    max-width: 150px;
    max-height: 150px;
    border: none;
}

.create-services {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-end;
    }
</style>